<template>
  <button
    type="button"
    class="shrink-0 rounded-full flex items-center justify-center text-cta-tertiary-outline-icon hover:bg-container-bg hover:text-strongest active:scale-95 transition-colors"
    :class="size === 'sm' ? 'h-6 w-6' : 'h-9 w-9'"
    @click="copy"
  >
    <Transition name="fd-fade" mode="out-in">
      <Icon
        :key="copied ? 'check' : 'copy'"
        :name="copied ? 'Check' : 'Copy'"
        :class="[size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4', copied ? 'text-success' : '']"
      />
    </Transition>
  </button>
</template>

<script setup>
import { ref, onBeforeUnmount } from "vue";
import Icon from "./Icon.vue";

const props = defineProps({
  text: { type: String, required: true },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md"].includes(value),
  },
});

const copied = ref(false);
let resetTimer;

async function copy() {
  try {
    await navigator.clipboard.writeText(props.text);
    copied.value = true;
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
      copied.value = false;
    }, 10000);
  } catch (err) {
    console.error("Failed to copy:", err);
  }
}

onBeforeUnmount(() => clearTimeout(resetTimer));
</script>

<style scoped>
.fd-fade-enter-active,
.fd-fade-leave-active {
  transition: opacity 0.2s ease;
}
.fd-fade-enter-from,
.fd-fade-leave-to {
  opacity: 0;
}
</style>
